import { Component, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { Societe } from '../../../models/societe';

@Component({
  selector: 'app-popin',
  templateUrl: './popin.component.html',
  styleUrls: ['./popin.component.scss']
})
export class PopinComponent {

  selectedSociete: Societe;
  constructor(
    public dialogRef: MatDialogRef<PopinComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { console.log('data: ' + data); }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getSelectedSociete(societe: any){
    //this.selectedSociete = societe;
    this.dialogRef.close(societe);
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/utils/popin/popin.component.ts